import InitApi from "api/InitApi";
import { useQuery } from "react-query";
import useTokenStore from "store/tokenStore";
import { deleteEmptyObjects, fetchConfig } from "utils";

const useFetchPublisherBooks = (queryParams, userId = null) => {
	const { accessToken } = useTokenStore();
	const fetch = async () => {
		const instance = await InitApi({ accessToken });
		const params = queryParams ? deleteEmptyObjects(queryParams) : null;

		const parameters =
			params["filter[genre_is]"]?.length > 0 ||
			params["filter[genre_is]"] !== undefined
				? {
						...params,
						"filter[genre_is]": params["filter[genre_is]"]?.join("*"),
				  }
				: delete params["filter[genre_is]"];

		const url = userId ? `/books/publisher/${userId}` : `books/publisher`;

		const res = await instance.get(url, {
			params: { ...parameters },
		});
		return res.data;
	};
	return useQuery(["myUploadedBooks", queryParams, userId], () => fetch(), {
		...fetchConfig,
	});
};

export default useFetchPublisherBooks;
